import React, { Component } from 'react';
import pt from 'prop-types';

import StatsOfficeView from './StatsOfficeView';


class StatsOffice extends Component {
  componentDidMount() {
    const { officeId, getStats, } = this.props;

    getStats(officeId);
  }


  render() {
    const { 
      statsData,
      getStats,
    } = this.props;

    return (
      <StatsOfficeView
        statsData={statsData}
        getStats={getStats}
      />
    );
  }
}


StatsOffice.propTypes = {
  officeId: pt.string.isRequired,
  statsData: pt.object.isRequired,
  getStats: pt.func.isRequired,
}


export default StatsOffice;